// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"486":"7631b788","620":"c441d5df","791":"3d32ae20"}[chunkId] + ".chunk.css";
};